export function toISODate(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function mondayOf(dateStr: string): Date {
  /** 'YYYY-MM-DD'는 로컬 자정으로 읽음(new Date()는 UTC 자정이라 시간대에 따라 하루 밀릴 수 있음) */
  const date = /^\d{4}-\d{2}-\d{2}$/.test(dateStr) ? parseISODate(dateStr) : new Date(dateStr);
  const day = date.getDay(); // 0=Sun, 1=Mon
  const diff = day === 0 ? -6 : 1 - day;
  date.setDate(date.getDate() + diff);
  return date;
}

export function addDays(date: Date, days: number): Date {
  const copy = new Date(date);
  copy.setDate(copy.getDate() + days);
  return copy;
}

/** ISO 날짜 문자열을 Date로 (로컬 자정) */
export function parseISODate(iso: string): Date {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d);
}

/** 해당 날짜가 월~금인지 (토·일이면 false) */
export function isWeekday(iso: string): boolean {
  const d = parseISODate(iso).getDay();
  return d >= 1 && d <= 5;
}

/** 해당 날짜가 토·일인지 */
export function isWeekend(iso: string): boolean {
  const d = parseISODate(iso).getDay();
  return d === 0 || d === 6;
}

/** 두 날짜 구간 내 월~금 요일 수 (시작·종료 포함) */
export function countWeekdays(fromISO: string, toISO: string): number {
  const from = parseISODate(fromISO);
  const to = parseISODate(toISO);
  if (from.getTime() > to.getTime()) return 0;
  let count = 0;
  const cur = new Date(from);
  while (cur.getTime() <= to.getTime()) {
    const day = cur.getDay();
    if (day >= 1 && day <= 5) count += 1;
    cur.setDate(cur.getDate() + 1);
  }
  return count;
}

/** 날짜를 "0000년 00월 00일" 형식으로 (월·일 2자리) */
export function formatDateKor(iso: string): string {
  const [y, m, d] = iso.split('-');
  return `${y}년 ${m}월 ${d}일`;
}

/** 두 날짜 구간 일수 (시작·종료 포함) */
export function countDays(fromISO: string, toISO: string): number {
  const from = parseISODate(fromISO).getTime();
  const to = parseISODate(toISO).getTime();
  if (from > to) return 0;
  return Math.floor((to - from) / (24 * 60 * 60 * 1000)) + 1;
}

/** 날짜를 "M월 D일" 형식으로 (목록 표시용) */
export function formatDateShort(iso: string): string {
  const [, m, d] = iso.split('-').map(Number);
  return `${m}월 ${d}일`;
}

